import PropTypes from 'prop-types'
import { connect } from "react-redux"
import axios from "axios"
import React, { useRef, useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Label,
  Input,
  FormGroup,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"
import Storage from '@aws-amplify/storage'
import ReCAPTCHA from "react-google-recaptcha";
import {
  addReferral,
} from "../../store/affiliate/actions"


const Referrals = props => {
 const {
    onAddReferral,
    onGetReferral
  } = props
  const recaptchaRef = useRef(null)
  const [emails, setEmails] = useState()
  const [username, setUsername] = useState()
  const [welcome, setWelcome] = useState()
  const [password, setPassword] = useState()
  const [error, setError] = useState(true)
  const [referral, setReferral] = useState()


  const checkSignup = async () => {
    
      const captchaToken = await recaptchaRef.current.getValue();
      recaptchaRef.current.reset();
      console.log(captchaToken);    
      const res = await axios.post(
          "https://sage.growmyownfood.com:5000/checkbot",
          { 
             captchaToken
          }
      );

      if (res.data == 'Human') {
	  var referral = {
	      "username": username,
	      "password": password,
	      "emails": emails,
              "welcome": welcome
	  }
          // save information then redirect
	  onAddReferral(referral)
      }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}

          <Row>
            <Col xl="12">
              <Row>
                  <Col md="6">
             <Card outline className="border">
                  <CardTitle>Sign up to refer friends to Pernaculture Gardens</CardTitle>
                  <CardSubtitle className="mb-3">
                    If you can get 10 new people to sign up to our Permaculture Gardens Tribe, we will reward you with a garden planning workbook to maximize your harvests.  
                  </CardSubtitle>
                  <CardBody>
                   <div className="form-group row">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-4 col-form-label"
                    >
                      Email
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="email"
	                 onChange={e => setUsername(e.target.value)}
                        value={username}
                      />
                    </div>
	            </div>

	             <div className="form-group row">
                    <label
                      htmlFor="password-input"
                      className="col-md-4 col-form-label"
                    >
                      Password
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="password"
	                 onChange={e => setPassword(e.target.value)}
                        value={password}
                      />
                    </div>
                  </div>
	          <FormGroup>
                       <Label for="referalEmails">Enter your friend's email address. <br/> <i>For multiple emails, separate by comma</i></Label>
                       <Input type="textarea" name="text" id="referalEmails" value={emails} onChange={e => setEmails(e.target.value)}
                      />
	          </FormGroup>
                  <FormGroup>
                       <Label for="welcomeEmail">Personalize your welcome email</Label>
                       <Input type="textarea" name="text" value={welcome} id="welcomeEmail" onChange={e => setWelcome(e.target.value)}
                      />
                  </FormGroup>


	      <ReCAPTCHA
                           ref={recaptchaRef}
                            sitekey={"6LdWeYIfAAAAAKLlNzKN-nEQY-lwh2EmhaQFBXLz"}
                       />


	          <Button className="btn-success" onClick={checkSignup} href=""><span style={{ color:"#000000"}}>Submit</span></Button>
	         </CardBody>
	      </Card>

	      </Col>

	      <Col md="6">
                 <Card outline className="border">
                  <CardTitle>Login</CardTitle>
                  <CardSubtitle className="mb-3">
                    You can login to see how many of your referrals have confirmed to join Permaculture Gardens.
                  </CardSubtitle>
                  <CardBody>
	           <div className="form-group row">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-4 col-form-label"
                    >
                      Email
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="email"
                        defaultValue=""
                      />
                    </div>
	           </div>

                     <div className="form-group row">
                    <label
                      htmlFor="password-input"
                      className="col-md-4 col-form-label"
                    >
                      Password
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="password"
                        defaultValue=""
                      />
                    </div>
                  </div>

                  <Button className="btn-warning" href=""><span style={{ color:"#000000"}}>Login</span></Button>

                  </CardBody>
	        </Card>
	      </Col>
              
              </Row>

            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  )
}

Referrals.propTypes = {
  onGetReferral: PropTypes.func,
  onAddReferral: PropTypes.func,
  onUpdateReferral: PropTypes.func,
}


const mapStateToProps = ({ referrals }) => {
  return ({})
}


const mapDispatchToProps = dispatch => ({
  onAddReferral: (referral) => dispatch(addReferral(referral)),
  //onGetAnnouncements: () => dispatch (getAnnouncements()),
  //onUpdateProfile: user => dispatch(updateProfile(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Referrals)

